import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { UserRole } from '../config/permissions';

interface ProtectedRouteProps {
  allowedRoles: UserRole[];
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ allowedRoles, children }) => {
  const { token, role } = useAuth();
  if (!token) return <Navigate to="/login" />;

  // Super admin must be able to open all protected routes.
  if (String(role || '').toLowerCase() === 'super_admin') {
    return <>{children}</>;
  }

  // Case-insensitive role comparison for Admin/Manager/Editor/Viewer/Staff.
  const currentRole = String(role || '').toLowerCase();
  const allowed = allowedRoles.map(r => String(r).toLowerCase());
  if (!allowed.includes(currentRole)) {
    return <Navigate to="/dashboard" />;
  }
  return <>{children}</>;
};

export default ProtectedRoute;
